import React, {useCallback, useContext} from 'react';
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {IntervistaContext} from "../IntervistaOld";
import {AppContext} from "../../../../../App";
import {setOpenSnackbar} from "../../../../../services/AppServices";
import {setIntervista} from "../../../../../services/IntervistaServices";
import {useFormContext} from "react-hook-form";
import {
	AccordionActions,
	AccordionDetails,
	Button,
	Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import {MedicoGrid} from "../content/MedicoGrid";

const MedicoStep = ({setStep}) => {
	const classes = BaseStyle();
	const intervistaContext = useContext(IntervistaContext);
	const {getValues, trigger} = useFormContext();
	const appContext = useContext(AppContext);
	
	const goForward = useCallback(async () => {
		let result = await trigger([
			("cognomeMedico"),
			("nomeMedico"),
			("fissoMedico"),
			("emailMedico"),
			("cellMedico"),
		]);
		if (result) {
			setIntervista(getValues(), intervistaContext.dispatch);
			setStep(prevState => ++prevState);
		} else {
			setOpenSnackbar("error", "Controlla bene i dati inseriti!", appContext.dispatch);
		}
	}, [intervistaContext.dispatch, appContext.dispatch, setStep, trigger, getValues])
	
	return (
		<React.Fragment>
			<AccordionDetails>
				<Grid container spacing={3}>
					<MedicoGrid/>
				</Grid>
			</AccordionDetails>
			<AccordionActions>
				<Tooltip title={"Torna al passo precedente"}>
					<Button size={"small"} variant={"text"}
					        style={{borderRadius: 24}}
					        className={classes.roundButton} onClick={() => setStep(2)}>
						<b>Torna indietro</b>
					</Button>
				</Tooltip>
				<Tooltip title={"Prosegui con il passo successivo"}>
					<Button size={"small"} color={"primary"} variant={"contained"}
					        disableElevation
					        style={{borderRadius: 24}}
					        className={classes.roundButton}
					        onClick={goForward}>
						<b>Prosegui</b>
					</Button>
				</Tooltip>
			</AccordionActions>
		</React.Fragment>
	);
};

export default React.memo(MedicoStep)
